import ModalNotification from '@src/views/dashboard/ModalNotification';
import React, { createContext, useState } from 'react';

type ModalNotificationContextData = {
  modal?: string;
};

export const ModalNotificationContext = createContext(
  {} as ModalNotificationContextData
);

export const ModalNotificationProvider: React.FC = ({ children }) => {
  const [modal, setModal] = useState('modal');

  return (
    <ModalNotificationContext.Provider value={{ modal }}>
      <ModalNotification />
      {children}
    </ModalNotificationContext.Provider>
  );
};
